export enum PortalType {
  Internal = 'internal',
  Member = 'members',
  Employer = 'employers'
}
